<template>
    <div></div>
</template>

<script>
    import * as turf from "@turf/turf";

    export default {
        name: "Curve2d",
        props:{
            map:{
                required: true // mapbox对象
            },
            color:{
                required: false,
                default: '#FFFFFF'
            },
            width:{
                required: false,
                default:4
            },
            opacity:{
                required: false,
                default:1
            },
            lineData:{
                required: true // 线数据列表，需要geoJson: FutureCollection<Future<Point>>
            },
        },
        methods:{
          initLayer(){
              this.map.addSource('lineLayer_2d',{
                  type:"geojson",
                  data:this.lineData,
                // lineMetrics:true
              })

              this.map.addLayer({
                  id: 'lineLayer_2d_line',
                  type: 'line',
                  source: 'lineLayer_2d',

                  paint: {
                      'line-color': this.color,
                      'line-width':this.width,
                      'line-opacity': this.opacity,
                      // 'line-blur':3,
                      // 'line-gradient': [
                      //   'interpolate',
                      //   ['linear'],
                      //   ['line-progress'],
                      //   0, "blue",
                      //   0.1, "royalblue",
                      //   0.3, "cyan",
                      //   0.5, "lime",
                      //   0.7, "yellow",
                      //   1, "red"
                      // ]
                  }
              })//线


              this.mapFitBoundary(this.lineData)
          },
            removeLineLayer(){
              if(this.map.getLayer('lineLayer_2d_line'))
                  this.map.removeLayer('lineLayer_2d_line')
              if(this.map.getSource('lineLayer_2d'))
                  this.map.removeSource('lineLayer_2d')
            },
            mapFitBoundary(geo){
                const bbox = turf.bbox(geo)
                this.map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]],{
                    linear: false,
                    animate: true,
                    padding: {top: 0, bottom:0, left: 0, right: 0},
                })
            },
        },
        mounted() {
            this.initLayer()
        },
        destroyed() {
            this.removeLineLayer()
        }
    }
</script>

<style scoped>

</style>
